import script from "./RefundList.vue?vue&type=script&setup=true&lang=js"
export * from "./RefundList.vue?vue&type=script&setup=true&lang=js"

import "./RefundList.vue?vue&type=style&index=0&id=fd3fd4f4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd3fd4f4"]])

export default __exports__